import { IBaseMarketplaceItem } from '../merketplace';
import { IP2pBaseItem } from './p2p-base-item.interface';

export interface IP2pPurchaseItem extends IBaseMarketplaceItem, IP2pBaseItem {
  isActive?: boolean;
  items?: any[]; // Это надо убрать как только появится возможность сделать человеческий интерфейс для продаж
}
